"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PinterestSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PinterestSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Pinterest"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "pinterest-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,7.5H18.571A11.084,11.084,0,0,0,7.5,18.571V81.429A11.084,11.084,0,0,0,18.571,92.5H81.429A11.084,11.084,0,0,0,92.5,81.429V18.571A11.084,11.084,0,0,0,81.429,7.5ZM87.5,81.429A6.079,6.079,0,0,1,81.429,87.5H18.571A6.079,6.079,0,0,1,12.5,81.429V18.571A6.079,6.079,0,0,1,18.571,12.5H81.429A6.079,6.079,0,0,1,87.5,18.571Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.009,24.011c-10.891,0-22.157,7.5-22.157,20.063,0,6.988,3.578,12.1,7.616,13.732A40.143,40.143,0,0,0,35.412,66a36.933,36.933,0,0,0,.282,4.07c.041.381.082.763.119,1.147a5,5,0,0,0,1.228,2.834,5.12,5.12,0,0,0,4,1.937,5.267,5.267,0,0,0,2.045-.421,5,5,0,0,0,2.322-1.748c3.045-4.169,4.176-6.413,5.155-9.748a12.484,12.484,0,0,0,2.641.293c11.781,0,17.944-10.842,17.944-21.552C71.148,32.27,62.3,24.011,51.009,24.011Zm2.2,35.354c-2.119,0-4.794-1.06-5.828-3.028-1.918,7.595-1.766,8.73-6,14.533a1.831,1.831,0,0,1-.33.119c-.066,0-.093-.069-.251-.245-.151-1.589-.378-3.154-.378-4.743,0-5.147,2.372-12.591,3.532-17.587a9.892,9.892,0,0,1-.807-4.264c0-3.8,2.515-5.773,4.707-5.773,1.691,0,3.19,1.178,3.19,3.6,0,3.28-2.22,6.359-2.22,9.538A3.735,3.735,0,0,0,52.7,55.2c5.8,0,7.595-8.377,7.595-12.843,0-5.98-4.239-9.235-9.967-9.235-6.661,0-11.808,4.794-11.808,11.556,0,3.255,1.993,4.92,1.993,5.7,0,.656-.48,2.978-1.312,2.978-2.019,0-5.349-3.365-5.349-9.286,0-9.31,8.528-15.063,17.157-15.063,7.923,0,15.139,5.45,15.139,13.8C66.148,50.66,62.136,59.365,53.2,59.365Z"
  })))));
}